import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { ConfigService } from './config.service';
import {
  CreateFavoriteService,
  FavoriteService as QPFavoriteService,
} from 'qp-storefront';
import { KEYS } from '../utils/constants/storage.constants';
import { LocalStorageService } from './storage/local-storage.service';
import { StorefrontPolicyService } from './firstlight/storefront-policy/storefront-policy.service';
import {
  FavouriteService as FLFavoriteService,
  createFavouriteService,
} from 'fl-favourites';
import { FavoriteData } from 'qp-ui-interface';
import { resourceAdaptor } from 'qp-adaptor';
import { getDeviceType } from '../utils/deviceUtils';
import { NewrelicService } from 'src/app/analytics/newrelic/services/newrelic.service';

@Injectable({
  providedIn: 'root',
})
export class FavouriteService {
  private _qpInstance: QPFavoriteService;
  private _flInstance: FLFavoriteService;

  constructor(
    private readonly configService: ConfigService,
    private readonly localStorageService: LocalStorageService,
    private readonly storefrontPolicyService: StorefrontPolicyService,
    private readonly authService: AuthService,
    private readonly newrelicService: NewrelicService
  ) {}

  qpInstance() {
    if (!this._qpInstance) {
      this._qpInstance = CreateFavoriteService(
        this.configService.applicationConfig.favoriteURL
      );
    }
    return this._qpInstance;
  }

  async getQpFavorites() {
    try {
      const xauthToken = this.localStorageService.getItem(
        KEYS.EVERGENT_OVAT_TOKEN
      );
      const authToken = this.localStorageService.getItem(KEYS.PLATFORM_TOKEN);
      const pageSize = this.configService.favoritesPageSize();
      const result = await this.qpInstance().getFavoriteItems(
        xauthToken,
        authToken,
        true,
        pageSize,
        this.storefrontPolicyService.getPolicy()
      );
      if (result?.length) {
        const adaptFav = this.favAdapter([...result]);
        return adaptFav;
      }
      return null;
    } catch (exception) {
      console.warn('favourite error', exception);
      this.newrelicService.sendErrorEvent(
        {
          error: exception,
        },
        null,
        true
      );
      return null;
    }
  }

  async getFavouriteCount() {
    try {
      return await this.authService.favoriteService.getFavouriteCount();
    } catch (exception) {
      this.newrelicService.sendErrorEvent({
        error: exception,
      });
      return null;
    }
  }

  async getFavourite(contentId: string) {
    try {
      return await this.authService.favoriteService.getFavourite(contentId);
    } catch (exception) {
      if (exception?.internalError?.errorCode != '40040303') {
        this.newrelicService.sendErrorEvent({
          error: exception,
        });
      }
      return false;
    }
  }

  async putFavourite(contentId: string) {
    try {
      await this.authService.favoriteService.putFavourite(contentId);
      return true;
    } catch (exception) {
      this.newrelicService.sendErrorEvent({
        error: exception,
      });
      return null;
    }
  }

  async deleteFavourite(contentId: string) {
    try {
      await this.authService.favoriteService.deleteFavourite(contentId);
      return true;
    } catch (exception) {
      this.newrelicService.sendErrorEvent({
        error: exception,
      });
      return null;
    }
  }

  private favAdapter(_resources: FavoriteData[]): any {
    let favContainer = {
      aspectRatio: '2x3',
      id: 'cvm-Favorites',
      layout: 'carousel',
      name: 'Watchlist',
      resources: [],
      localizedName: {
        en: { n: 'Watchlist' },
      },
    };
    const favoriteResource = _resources?.filter(
      (status) => status.content_status === 'found'
    );
    const resources = favoriteResource?.map((item) => {
      const resource = resourceAdaptor(
        this.configService.applicationConfig.imageResizeURL,
        item.info,
        getDeviceType(),
        '0-2x3'
      );
      resource.containerName = { en: 'Watchlist' };
      resource.containerId = 'Watchlist';
      return resource;
    });
    favContainer = {
      ...favContainer,
      resources,
    };
    return favContainer;
  }
}
